export default {
  FlightNumber__FLIGHT_INFORMATION_ARIA_LABEL: (data) =>
    `Information for flight number ${data.AIRLINE_CODE ? ` ${data.AIRLINE_CODE}` : ""} ${
      data.FLIGHT_NUMBER
    }.`,
};
